// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"styles_videoContainer__c4Bup","isFullScreen":"styles_isFullScreen__owwI7","btnPlay":"styles_btnPlay__NE7Hh"};